<template>
  <transition name="fade">
    <div class="parallax" v-if="scrollY >= showWhen">
      <div class="parallax-content">
        <img class="parallax-logo-img" :src="logo" />
        <div class="ml-4" @click="$emit('clickOnSwitchBranch')">
          <p class="crm-restaurant-name text-1-line ma-0 pb-2 pt-2">
            {{ restaurantName }}
          </p>
          <div class="d-flex">
            <p class="crm-branch-name text-1-line ma-0">
              {{ $t('components.home.branches') }} {{ branchName }}
            </p>
            <span
              ><svg-arrow-down-circle class="crm-arrow-down-circle ml-2"
            /></span>
          </div>
        </div>
        <div class="parallax-points" @click="$emit('clickOnPoints')">
          <p class="parallax-points-number ma-0 pt-2">
            {{ numberWithCommas(points == "" ? 0 : points) }}
          </p>
          <p class="parallax-points-text ma-0">{{ $t('components.history.point') }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import mixins from "@/helper/mixins";
import scrollMixins from "@/helper/scroll-mixins";
const SvgArrowDownCircle = () => import("@/assets/svg/arrow-down-circle.svg");

export default {
  mixins: [mixins, scrollMixins],
  components: {
    SvgArrowDownCircle,
  },
  props: {
    restaurantName: String,
    branchName: String,
    logo: String,
    points: Number,
    showWhen: Number,
  },
};
</script>

<style>
.parallax {
  position: fixed;
  top: 0px;
  z-index: 2;
  height: var(--header-height);
  width: 100%;
  max-width: var(--max-width-app);
  background-image: url("../../assets/svg/background.svg?inline");
  background-repeat: no-repeat;
  background-color: var(--primary);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.parallax-content {
  display: flex;
  align-items: center;
  height: 100%;
  color: #ffffff;
}
.parallax-points {
  margin-left: auto;
  margin-right: 16px;
  text-align: right;
}
.parallax-points-number {
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
}
.parallax-points-text {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

.parallax-logo-img {
  margin-left: 16px;
  text-align: center;
  border: 1px solid #ffffff;
  border-radius: 50%;
  /* margin-right: 19px; */
  width: 36px;
  height: 36px;
}

.crm-restaurant-name {
  font-size: 24px;
  font-weight: 500;
  line-height: 16px;
}
.crm-branch-name {
  font-size: 14px;
  font-weight: lighter;
  line-height: 16px;
}

.fade-enter-active {
  transition: opacity 300ms;
}
.fade-leave-active {
  transition: opacity 80ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>